import { PaymentsTranslations } from "./paymentTranslations.types";
import { getCgvLink } from "@/service/legalLinks/legalLinksService";

const cgvUrl = getCgvLink();

const paymentFrTranslations: PaymentsTranslations = {
    "paymentsPage": {
        "title": "Paiement",
        "paymentMyAccount": "Mon compte",
        "paymentChooseMethod": "Passer au paiement",
        "paymentByCreditCard": "Paiement par carte bancaire",
        "paymentByBancontact": "Paiement par Bancontact",
        "paymentByIdeal": "Paiement par iDeal",
        "proceedToPay": "Procéder au paiement",
        "paymentCreditCardPaymentCondition1Desc1": "Vous avez choisi une offre Flex. Nous procédons ce jour au débit de",
        "paymentCreditCardPaymentCondition1Desc2": "correspondant à",
        "paymentCreditCardPaymentCondition1Desc3": "du montant de votre commande.",
        "paymentCreditCardPaymentCondition1Desc4": "Le solde, soit",
        "paymentCreditCardPaymentCondition1Desc5": ", sera prélevé automatiquement le",
        "paymentCreditCardPaymentCondition1Notice1": "30% d’acompte à la commande, modification gratuite jusqu’au",
        "paymentCreditCardPaymentCondition1Notice12": "(hors frais de dossier et assurances souscrites)",
        "paymentCreditCardPaymentCondition1Notice22": ". Modification des prestations hors hébergements selon les",
        "paymentCreditCardPaymentCondition1Notice23": "conditions générales de vente.",
        "paymentCreditCardPaymentCondition1DescPvBeforeDeposit1": "Vous avez choisi une offre Flex. Nous procédons ce jour au débit de",
        "paymentCreditCardPaymentCondition1DescPvBeforeDeposit2": "correspondant à",
        "paymentCreditCardPaymentCondition1DescPvBeforeDeposit3": "du montant de votre commande.",
        "paymentCreditCardPaymentCondition1DescPvBeforeDeposit4": "Le solde, soit",
        "paymentCreditCardPaymentCondition1DescPvBeforeDeposit5": ", sera prélevé automatiquement le",
        "paymentCreditCardPaymentCondition1NoticePvBeforeDeposit1": "30% d’acompte à la commande, modification gratuite jusqu’au",
        "paymentCreditCardPaymentCondition1NoticePvBeforeDeposit2": "(hors frais de dossier et assurances souscrites). Modification des prestations hors hébergements selon les",
        "paymentCreditCardPaymentCondition1NoticePvBeforeDeposit3": "conditions générales de vente.",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit1": "Vous avez choisi une offre Flex. Nous procédons ce jour au débit de",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit2": ", correspondant à 100% du montant de votre commande.",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit3": "Annulation et modification gratuites jusqu’au",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit4": "(hors frais de dossier et assurances souscrites). Modification des prestations hors hébergements selon les",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit5": "conditions générales de vente.",
        "paymentCreditCardPaymentCondition1NoticePvAfterDeposit1": "Paiement total à la commande.",
        "paymentCreditCardPaymentCondition2Desc1": "Vous avez choisi une offre Fixe. Nous procédons ce jour au débit de",
        "paymentCreditCardPaymentCondition2Desc2": ", correspondant à 100% du montant de votre commande.",
        "paymentCreditCardPaymentCondition2Desc3": "Non remboursable. Modification des prestations hors hébergements selon les",
        "paymentCreditCardPaymentCondition2Desc4": "conditions générales de vente.",
        "paymentCreditCardPaymentCondition2Notice1": "Paiement total à la commande. Non remboursable.",
        "paymentErrorPopupTitle": "Paiement refusé",
        "paymentErrorPopupText": "Désolé mais votre paiement vient d’être refusé. Veuillez réessayer ou contactez-nous au",
        "paymentErrorPopupButton": "OK",
        "paymentStatusCheckPayment": "Vérification du paiement",
        "paymentStatusConfirmPayment": "Confirmation du paiement",
        "paymentStatusCheckAvailability": "Vérification de la disponibilité du logement",
        "loadingPrice": "Chargement du prix...",
        "accommodationUnavailable": "Logement non disponible",
        // Train-only
        "trainOnlyConditionsDescription": `Annulation et modification selon les <a href="${cgvUrl}" target="_blank" rel="noopener">conditions générales de vente</a>.`,

        "paymentCreditCardPaymentCondition1DescPvAfterDeposit6": "Description after deposit 6", // Add appropriate text
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit7": "Description after deposit 7", // Add appropriate text
        "paymentCreditCardPaymentCondition1Notice24": "Notice 24 text", // Add appropriate text
        "paymentCreditCardPaymentCondition1Notice25": "Notice 25 text", // Add appropriate text
        "paymentCreditCardPaymentCondition1NoticePvBeforeDeposit4": "Notice text 4", // Add appropriate text
        "paymentCreditCardPaymentCondition1NoticePvBeforeDeposit5": "Notice text 5", // Add appropriate text
        "paymentCreditCardPaymentCondition2Desc5": "Description text 5", // Add appropriate text
        "paymentCreditCardPaymentCondition2Desc6": "Description text 6", // Add appropriate text
        "paymentConditionsDescriptionFlex": `Modification gratuite jusqu'au <b>slot_date</b> (hors frais de dossier et assurances souscrites). Modification des prestations hors hébergements selon les <a href="${cgvUrl}" target="_blank">conditions générales de vente.</a>`,
        "paymentConditionsDescriptionFixe": "Paiement total à la commande. Non remboursable.",
        "fixeProduct": "Fixe",
        "flexProduct": "Flex",
        "paymentAmountDescriptionFlex": "Les soldes de chacun des paiements suivants seront prélevés automatiquement aux dates indiquées ci-dessus.",
        "paymentAmountDescriptionFixe": "Vous avez choisi une offre Fixe. Nous procédons ce jour au débit de deposit_amount, correspondant à 100% du montant de votre commande.",
        "paymentNotReady": "Paiement non prêt",
        "checkParticipants": "Vérifier les informations des participants",
        "checkFlight": "Vérifier la disponibilité du vol",
        "checkAccommodationStock": "Vérifier le stock d'hébergement",
        "accommodationNoLongerAvailable": "Cet hébergement n'est plus disponible",
        "accommodationUnavailableModalTitle": "Cet hébergement n'est plus disponible.",
        "accommodationUnavailableModalText1": "Malheureusement, l'hébergement que vous avez sélectionné n'est plus disponible.",
        "accommodationUnavailableModalText2": "Nous vous invitons à sélectionner un autre hébergement parmi nos offres.",
        "accommodationUnavailableModalClose": "Fermer",
        "accommodationUnavailableModalCta": "Voir d'autres hébergements",
        "fillParticipantsDetailsMessage": "Merci d'indiquer les noms, prénoms et dates de naissance de tous les participants pour passer au paiement ou sauvegarder votre devis.",
        "paymentModeTitle": "Choisissez votre option de paiement",
        "payNowPartial": "Payer l'acompte maintenant",
        "payNowFull": "Payer la totalité maintenant",
        "payLater": "scheduled_amount le slot_date",
        "payInitialDepositNow": "Réglez l'acompte initial dès maintenant : {amount} / pers.",
        "scheduledSecondDepositLine": "2e acompte de {amount} à régler le {date}",
        "scheduledBalanceLine": "Solde de {amount} à régler le {date}",
        "scheduledFurtherPaymentLine": "Autre échéance de {amount} à régler le {date}",
        "remainingToPayAdyen": "Reste à payer : <b>{amount}</b>",
    },
    "systempayError": {
        "0": "",
        "2": "",
        "3": "",
        "4": "",
        "5": "Votre paiement n'a pas été approuvé par votre établissement bancaire.\n\nNous vous recommandons de contacter votre banque pour plus d'informations, ou d'essayer une autre méthode de paiement.\n\nMerci pour votre compréhension.",
        "7": "",
        "8": "",
        "12": "",
        "13": "",
        "14": "",
        "15": "",
        "17": "",
        "19": "",
        "20": "",
        "24": "",
        "25": "",
        "26": "",
        "27": "",
        "28": "",
        "29": "",
        "30": "",
        "31": "",
        "33": "",
        "34": "",
        "38": "",
        "41": "",
        "43": "",
        "46": "",
        "51": "Nous sommes navrés mais votre paiement n'a pas pu être effectué en raison d'un solde insuffisant ou d'un dépassement de votre crédit autorisé.\n\nNous vous invitons à vérifier votre compte ou à contacter votre banque pour plus d'informations. Vous pouvez également choisir un autre moyen de paiement.\n\nMerci de votre compréhension.",
        "54": "Nous sommes navrés mais votre paiement n'a pas pu être validé en raison de la date de validée dépassée de votre carte bancaire. Veuillez vérifier les informations de votre paiement et réessayer. Si le problème persiste, nous vous invitons à contacter notre service client ou à utiliser une autre méthode de paiement. Merci de votre compréhension",
        "55": "",
        "56": "",
        "57": "Nous sommes navrés mais votre paiement n'a pas pu être validé, car ce type de transaction n'est pas autorisé pour votre carte.\n\nNous vous recommandons de contacter votre banque pour plus d'informations ou d'utiliser un autre moyen de paiement.\n\nMerci de votre compréhension.",
        "58": "",
        "59": "Nous sommes désolés, mais votre paiement n'a pas pu être validé en raison d'une suspicion de fraude. Pour des raisons de sécurité, nous avons suspendu cette transaction.\n\nVeuillez vérifier les informations de votre paiement et réessayer. Si le problème persiste, nous vous invitons à contacter notre service client ou à utiliser une autre méthode de paiement.\n\nMerci de votre compréhension.",
        "60": "",
        "61": "Nous sommes navrés mais votre paiement n'a pas pu être validé en raison d'un dépassement du montant de retrait autorisé.    Nous vous invitons à vérifier votre compte ou à contacter votre banque pour plus d'informations. Vous pouvez également choisir un autre moyen de paiement.\n\nMerci de votre compréhension.",
        "63": "",
        "65": "Nous sommes navrés mais votre paiement n'a pas être validé en raison d'un dépassement du nombre de retrait autorisé.  Nous vous invitons à vérifier votre compte ou à contacter votre banque pour plus d'informations. Vous pouvez également choisir un autre moyen de paiement.\n\nMerci de votre compréhension.",
        "68": "",
        "75": "",
        "76": "",
        "78": "",
        "80": "",
        "81": "",
        "82": "",
        "83": "",
        "84": "",
        "86": "",
        "88": "",
        "90": "",
        "91": "",
        "94": "",
        "96": "",
        "97": "",
        "98": "",
        "99": ""
    },
    "participant": {
        title: "Détails des participants",
        addParticipant: "Ajouter un participant",
        removeParticipantModalTitle: "Supprimer un participant",
        removeParticipantModalBody : "Voulez-vous vraiment supprimer le participant",
        removeParticipantModalDismiss: "Annuler",
        removeParticipantModalValidate: "Supprimer",
        participant: "Participant",
        yearsOld: "ans",
        checkNameTitle: "VÉRIFIEZ VOS NOMS",
        checkNameContent: "Chaque nom doit apparaître exactement comme dans votre document d'identité.",
        checkNameContentLikeInPassport: "Chaque nom doit apparaître exactement comme dans le passeport.",
        placeholderDataWarning: "Pensez à compléter les noms, prénoms et dates de naissance de chacun des participants.",
        male: "Homme",
        female: "Femme",
        firstName: "Prénom",
        lastName: "Nom de famille",
        dayShort: "JJ",
        monthShort: "MM",
        yearShort: "AAAA",
        dateOfBirth: "date de naissance",
        submit: "Enregistrer",
        delete: "Supprimer le participant",
        childTrainFreeMessage: "Votre enfant de -3 ans voyage gratuitement sur votre couchette."
    },
    "quote": {
        "saveYourQuote": "Sauvegarder votre recherche",
        "devisDesc1": "En sauvegardant votre recherche vous pourrez le <b>retrouver sur votre espace personnel via la rubrique \"Mon compte Client\"</b> pour procéder au paiement dès que vous le souhaitez. <br> <br> <b>À noter :</b>  la disponibilité de votre séjour sera à re-vérifier au moment de la réservation",
        "devisDesc4": "la disponibilité de votre séjour sera à re-vérifier au moment de la réservation",
        "devisDesc5": "la disponibilité de votre séjour sera à re-vérifier au moment de la réservation",
        "save": "Sauvegarder",
        "makeQuote": "Votre recherche de séjour"

    }
}

export default paymentFrTranslations;